import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import { Link } from 'ui/base/link';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';

import { BasePath } from 'services/base/page_path';

import { Pangolin } from 'services/accounts/types';

import { Host } from 'services/pangolin/types';

import {
  hostDisplayName,
  hostDisplayDeviceType,
} from 'services/pangolin/hosts_service';

import {
  themedDeviceTypeIconClassStyles,
  getDeviceTypeIcon,
} from 'assets/enums/device_types/device_types';

import baseStyles from './device_display.module.css';

type DeviceDisplayStyles = {
  link: string;
  devices: string;
  deviceRow: string;
  deviceColumn: string;
  deviceIcon: string;
  deviceName: string;
  deviceDetails: string;
  offline: string;
};

const themedStyles: ThemedStyles<DeviceDisplayStyles> = {
  [Theme.DAYLIGHT]: {
    link: baseStyles.daylightLink,
    devices: baseStyles.devices,
    deviceRow: baseStyles.deviceRow,
    deviceColumn: baseStyles.deviceColumn,
    deviceIcon: baseStyles.deviceIcon,
    deviceName: baseStyles.deviceName,
    deviceDetails: baseStyles.deviceDetails,
    offline: baseStyles.offline,
  },
  [Theme.MIDNIGHT]: {
    link: baseStyles.midnightLink,
    devices: baseStyles.devices,
    deviceRow: baseStyles.deviceRow,
    deviceColumn: baseStyles.deviceColumn,
    deviceIcon: baseStyles.deviceIcon,
    deviceName: baseStyles.deviceName,
    deviceDetails: baseStyles.deviceDetails,
    offline: baseStyles.offline,
  },
};

type DeviceDisplayProps = {
  host: Host;
  pangolin: Pangolin;
};

export const DeviceDisplay = ({ host, pangolin }: DeviceDisplayProps) => {
  const styles = useStyles(themedStyles);
  const deviceIcons = useStyles(themedDeviceTypeIconClassStyles);
  const deviceIconClass = getDeviceTypeIcon(deviceIcons, hostDisplayDeviceType(host));
  return (
    <Link path={{ kind: BasePath.DEVICES_VIEW, pangolinID: pangolin.id, deviceID: host.id }} className={styles.link}>
      <div className={classNames(styles.devices, !host.isOnline && styles.offline)}>
        <div className={styles.deviceRow}>
          <div>
            <div className={classNames(styles.deviceIcon, deviceIconClass)}/>
          </div>
          <div className={styles.deviceName}>
            {hostDisplayName(host)}
          </div>
          <div className={styles.deviceColumn}>
            <div className={styles.deviceDetails}>
              {moment(host.lastSeen).fromNow()}
            </div>
            <div className={styles.deviceDetails}>
              {host.ip}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
